import React from "react";

const GenerateAccessProgress = (data) => {
  if (!data) return null;

  const timeline = [];
  let rejectedOccurred = false;

  const renderStep = (label, status, comment, key) => {
    let liClass = "";

    if (rejectedOccurred) liClass = "";
    else if (status === "APPROVED") liClass = "approved";
    else if (status === "REJECTED") {
      liClass = "rejected";
      rejectedOccurred = true;
    } else liClass = "in-progress";

    return (
      <li key={key} className={`${liClass} mb-2`}>
        <h6>{label}</h6>
        {label !== "Access Granted" &&
          (status === "APPROVED"
            ? "Approved"
            : status === "REJECTED"
            ? "Rejected"
            : "Pending")}
      </li>
    );
  };

  const deliveryStatus =
    data.firstApproveStatus?.toUpperCase() || "IN_PROGRESS";
  timeline.push(
    renderStep(
      "Delivery Lead",
      deliveryStatus,
      data.firstApproverComment,
      "deliveryLead"
    )
  );

  if (!rejectedOccurred) {
    const itStatus = data.secondApproveStatus?.toUpperCase() || "IN_PROGRESS";

    timeline.push(
      renderStep("IT Team", itStatus, data.secondApproverComment, "itTeam")
    );
  }
  if (
    !rejectedOccurred &&
    data.firstApproveStatus === "APPROVED" &&
    data.secondApproveStatus === "APPROVED"
  ) {
    timeline.push(renderStep("Access Granted", "APPROVED", null, "granted"));
  }

  return <>{timeline}</>;
};

export default GenerateAccessProgress;
